import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-user",
  templateUrl: "./med-icon-user.component.html",
})
export class MedIconUserComponent extends SvgMixinComponent {}
